<template>
<a href="https://www.smartcurrencyexchange.com/" v-if="this.biz=='corp'">
          <img src="/assets/img/smart_business.png" width="190" />
      </a>
    <a href="https://www.smartcurrencyexchange.com/" v-else>
          <img src="/assets/img/logo.png" />
      </a>
</template>
<script>

export default {
    name: 'Logo',
    props:['biz']
}
</script>
